export default __webpack_public_path__ + "static/media/lingswap-icon.c104f7fc.png";